"use client";

import { c as _c } from "react/compiler-runtime";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { useContext } from "timvir/context";
import { defaultSearch } from "timvir/search";
import { Action } from "./Action";
export function Dialog(props) {
  const $ = _c(32);
  const {
    toc
  } = useContext();
  let onClose;
  let onDispose;
  let open;
  let rest;
  if ($[0] !== props) {
    ({
      open,
      onClose,
      onDispose,
      ...rest
    } = props);
    $[0] = props;
    $[1] = onClose;
    $[2] = onDispose;
    $[3] = open;
    $[4] = rest;
  } else {
    onClose = $[1];
    onDispose = $[2];
    open = $[3];
    rest = $[4];
  }
  let t0;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      transform: "scale(0.98)"
    };
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      style: t0,
      query: "",
      commands: []
    };
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const [state, setState] = React.useState(t1);
  let t2;
  let t3;
  if ($[7] !== onDispose || $[8] !== open) {
    t2 = () => {
      if (open) {
        setState(_temp);
      } else {
        setState(_temp2);
        setTimeout(() => {
          onDispose?.();
        }, 200);
      }
    };
    t3 = [open, onDispose];
    $[7] = onDispose;
    $[8] = open;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  React.useEffect(t2, t3);
  let t4;
  let t5;
  if ($[11] !== state.query || $[12] !== toc) {
    t4 = () => {
      (async () => {
        const {
          edges
        } = await defaultSearch(toc).q(state.query);
        setState(state_2 => ({
          ...state_2,
          commands: edges
        }));
      })();
    };
    t5 = [toc, state.query];
    $[11] = state.query;
    $[12] = toc;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  React.useEffect(t4, t5);
  const t6 = state.style;
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="x13g9wyj xlrawln x101yacv x1xq1gxn xsfzzmd x2lah0s xqcrz7y x1bzjle x1ivwqqu x12oqio5 xd0payo xuxw1ft xb3r6kr xlyipyv">Context</div>;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ev => {
      const query = ev.currentTarget.value;
      setState(state_3 => ({
        ...state_3,
        query
      }));
    };
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== state.query) {
    t9 = <div className="x1wvxhgs xrvj5dj x1y6fwsi x6s0dn4 x1n2onr6 x2lah0s x1x0gksc"><input className="x1qhigcl x18yvd6t x1ghz6dp xc342km xjyslct x1qlqyl8 x1x0gksc xjbqb8w xvc674v x1tyz1jm x1a2a7pz xh8yej3" autoFocus={true} placeholder={"Type a command or search\u2026"} value={state.query} onChange={t8} /></div>;
    $[17] = state.query;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="x1yy59j4 xxk0z11 xqin4a2 xboafo0 x1flf930">Pages</div>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== onClose || $[21] !== state.commands) {
    let t12;
    if ($[23] !== onClose) {
      t12 = (t13, index) => {
        const {
          node
        } = t13;
        return <Action key={index} label={node.label} onClick={() => {
          onClose?.();
          window.location.href = node.path;
        }} />;
      };
      $[23] = onClose;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    t11 = state.commands.map(t12);
    $[20] = onClose;
    $[21] = state.commands;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <div>{t10}<div className="x1vd4hg5 xysyzu8">{t11}</div></div>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== rest || $[28] !== state.style || $[29] !== t12 || $[30] !== t9) {
    t13 = <dialog className="x1n2onr6 x78zum5 xdt5ytf xs83m0k x1iyjqo2 x13qp9f6 x1so62im x1jpgh95 x1c4omy1 xur7f20 x1j6rtzm x11gisft xvc674v xb3r6kr xhkombj x1717udv xc342km x19bbpc0" style={t6} {...rest}>{t7}{t9}{t12}</dialog>;
    $[27] = rest;
    $[28] = state.style;
    $[29] = t12;
    $[30] = t9;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}
function _temp2(state_1) {
  return {
    ...state_1,
    style: {
      opacity: 0,
      transform: "scale(0.95)"
    }
  };
}
function _temp(state_0) {
  return {
    ...state_0,
    style: {
      opacity: 1,
      transform: "none"
    }
  };
}